export default {
    props: {
        yAxisAxisCrossingValue: {
            type: [Object, Date, Array, String, Number],
            default: undefined,
            kComposite: 'yAxis.axisCrossingValue'
        }, 
        yAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.background'
        }, 
        yAxisBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.baseUnit'
        }, 
        yAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.color'
        }, 
        yAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.color'
        }, 
        yAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.opacity'
        }, 
        yAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.background'
        }, 
        yAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.border.color'
        }, 
        yAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.border.dashType'
        }, 
        yAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.border.width'
        }, 
        yAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.color'
        }, 
        yAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.font'
        }, 
        yAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.format'
        }, 
        yAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding'
        }, 
        yAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding.bottom'
        }, 
        yAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding.left'
        }, 
        yAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding.right'
        }, 
        yAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding.top'
        }, 
        yAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.template'
        }, 
        yAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.visible'
        }, 
        yAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.crosshair.visible'
        }, 
        yAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.width'
        }, 
        yAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.background'
        }, 
        yAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.border.color'
        }, 
        yAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.border.dashType'
        }, 
        yAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.border.width'
        }, 
        yAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.color'
        }, 
        yAxisLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.culture'
        }, 
        yAxisLabelsDateFormatsDays: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.days'
        }, 
        yAxisLabelsDateFormatsHours: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.hours'
        }, 
        yAxisLabelsDateFormatsMonths: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.months'
        }, 
        yAxisLabelsDateFormatsWeeks: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.weeks'
        }, 
        yAxisLabelsDateFormatsYears: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.years'
        }, 
        yAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.font'
        }, 
        yAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.format'
        }, 
        yAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin'
        }, 
        yAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin.bottom'
        }, 
        yAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin.left'
        }, 
        yAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin.right'
        }, 
        yAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin.top'
        }, 
        yAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.labels.mirror'
        }, 
        yAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding'
        }, 
        yAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding.bottom'
        }, 
        yAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding.left'
        }, 
        yAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding.right'
        }, 
        yAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding.top'
        }, 
        yAxisLabelsRotation: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.rotation'
        }, 
        yAxisLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.rotation.align'
        }, 
        yAxisLabelsRotationAngle: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.rotation.angle'
        }, 
        yAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.skip'
        }, 
        yAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.step'
        }, 
        yAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'yAxis.labels.template'
        }, 
        yAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.labels.visible'
        }, 
        yAxisLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'yAxis.labels.visual'
        }, 
        yAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.line.color'
        }, 
        yAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.line.dashType'
        }, 
        yAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.line.visible'
        }, 
        yAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.line.width'
        }, 
        yAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.color'
        }, 
        yAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.dashType'
        }, 
        yAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.visible'
        }, 
        yAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.width'
        }, 
        yAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.step'
        }, 
        yAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.skip'
        }, 
        yAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.color'
        }, 
        yAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.dashType'
        }, 
        yAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.visible'
        }, 
        yAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.width'
        }, 
        yAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.step'
        }, 
        yAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.skip'
        }, 
        yAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.minorTicks.color'
        }, 
        yAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorTicks.size'
        }, 
        yAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.minorTicks.visible'
        }, 
        yAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorTicks.width'
        }, 
        yAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorTicks.step'
        }, 
        yAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorTicks.skip'
        }, 
        yAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.majorTicks.color'
        }, 
        yAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorTicks.size'
        }, 
        yAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.majorTicks.visible'
        }, 
        yAxisMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorTicks.width'
        }, 
        yAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorTicks.step'
        }, 
        yAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorTicks.skip'
        }, 
        yAxisMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorUnit'
        }, 
        yAxisMax: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.max'
        }, 
        yAxisMin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'yAxis.min'
        }, 
        yAxisMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorUnit'
        }, 
        yAxisName: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.name'
        }, 
        yAxisNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.narrowRange'
        }, 
        yAxisPane: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.pane'
        }, 
        yAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'yAxis.plotBands'
        },         yAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.reverse'
        }, 
        yAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.background'
        }, 
        yAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.border.color'
        }, 
        yAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.border.dashType'
        }, 
        yAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.border.width'
        }, 
        yAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.color'
        }, 
        yAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.font'
        }, 
        yAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin'
        }, 
        yAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin.bottom'
        }, 
        yAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin.left'
        }, 
        yAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin.right'
        }, 
        yAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin.top'
        }, 
        yAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding'
        }, 
        yAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding.bottom'
        }, 
        yAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding.left'
        }, 
        yAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding.right'
        }, 
        yAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding.top'
        }, 
        yAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.position'
        }, 
        yAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.rotation'
        }, 
        yAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.text'
        }, 
        yAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.title.visible'
        }, 
        yAxisTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'yAxis.title.visual'
        }, 
        yAxisType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.type'
        }, 
        yAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.visible'
        }, 
        yAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.position'
        }, 
        yAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.icon.background'
        }, 
        yAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.icon.border.color'
        }, 
        yAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.icon.border.width'
        }, 
        yAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.icon.size'
        }, 
        yAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.icon.type'
        }, 
        yAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.notes.icon.visible'
        }, 
        yAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.background'
        }, 
        yAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.border.color'
        }, 
        yAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.border.dashType'
        }, 
        yAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.label.border.width'
        }, 
        yAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.color'
        }, 
        yAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.font'
        }, 
        yAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'yAxis.notes.label.template'
        }, 
        yAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.notes.label.visible'
        }, 
        yAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.label.rotation'
        }, 
        yAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.format'
        }, 
        yAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.position'
        }, 
        yAxisNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.line.dashType'
        }, 
        yAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.line.width'
        }, 
        yAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.line.color'
        }, 
        yAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.line.length'
        }, 
        yAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'yAxis.notes.data'
        },         yAxisNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'yAxis.notes.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/YAxis.js